import { DropdownWithoutOptions } from '../Dropdown'

import Dropdown from '../Dropdown'
import statesProvinces from './statesProvinces'

const supportedCountries = new Set(Object.keys(statesProvinces))

type Props = DropdownWithoutOptions & {
  className?: string
  handleChange: (fieldId: string, id: string) => void
  selectedCountry?: string
  inputId: string
}

DropdownStateProvince.defaultProps = {
  className: '',
}

function DropdownStateProvince(props: Props) {
  const { handleChange, inputId, selectedCountry, ...rest } = props

  if (!selectedCountry || !supportedCountries.has(selectedCountry)) {
    return null
  }

  const options =
    selectedCountry === 'US' || selectedCountry === 'CA'
      ? statesProvinces[selectedCountry]
      : []

  return (
    <Dropdown
      handleOptionChange={(id) => handleChange(inputId, id)}
      inputId={inputId}
      options={options}
      {...rest}
    />
  )
}

export default DropdownStateProvince
